import { updateRecordApi } from "./updateRecordApi";

export const updateRecordSetData = async (
  lang,
  setMessageResponse,
  cookies,
  credintial,
  setSuccessMessage,
  setBtnLoader,
  userId
) => {
  if(Object.keys(credintial).length == 0){
    setMessageResponse((prev) => ({
      ...prev,
      success: false,
      message: 'لايمكن تحديث لاشيء',
      isShow: true,
    }));
    setBtnLoader(() => false);
    return;
  }
  const response = await updateRecordApi(credintial, lang, cookies, userId);
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      type: "update",
      message: response.res.data.message,
      data: response.res.data.data,
    }));
    setBtnLoader(() => false);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
      setBtnLoader(() => false);
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
      setBtnLoader(() => false);
    }
  }
};
